import escapeRegexString from '../utils/escapeRegexString'
import { List } from 'immutable'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class KeywordHighlight extends PureComponent {
  static propTypes = {
    caseSensitive: PropTypes.bool,
    children: PropTypes.element,
    match: PropTypes.string,
    text: PropTypes.string,
    tokens: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(List)])
  }

  static defaultProps = {
    match: '',
    caseSensitive: false
  }

  getHighlights() {
    const { caseSensitive, match, text = '' } = this.props
    let { tokens } = this.props

    if (!text || text.trim().length === 0) {
      return ''
    }

    if (match && match.length) {
      tokens = [match]
    }

    if (!tokens) {
      return text
    }

    let matchOptions = 'g'
    if (!caseSensitive) {
      matchOptions += 'i'
    }

    return tokens.reduce((memo, token) => {
      const substring = new RegExp(
        `(\\b${escapeRegexString(token)}\\b)`,
        matchOptions
      )
      return memo.replace(substring, '<span class="highlight">$1</span>')
    }, text)
  }

  render() {
    const { children } = this.props
    const content = this.getHighlights().trim()

    if (!content) {
      return children || null
    }

    return <span dangerouslySetInnerHTML={{ __html: this.getHighlights() }} />
  }
}



// WEBPACK FOOTER //
// ../src/components/KeywordHighlight.js